import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { type QueryKey, useQueryClient } from "@msuite/ui/query";
import React from "react";
import { Can } from "@/components/citadel";
import { AddServiceModal } from "@/modals/organizations/add-service-modal";

/** Props Interface */
interface ServicesMenuProps {
	queryKey: QueryKey;
}

export function ServicesMenu({ queryKey }: ServicesMenuProps) {
	/** Hooks */
	const { t } = useTranslation();
	const addServiceModal = useDisclosure();
	const qc = useQueryClient();

	/** Functions */
	async function handleOnComplete() {
		await qc.invalidateQueries({ queryKey });
	}

	/** Render */
	return (
		<React.Fragment>
			{/* Creating a service is `create Service` on the server, and the modal's number
			    suggestion is gated on the same rule — so the button goes with them. */}
			<Can
				action="create"
				subject="Service"
			>
				<Button
					variant="primary"
					icon={<Icon name="Plus" />}
					onClick={addServiceModal.onOpen}
					data-cy="services-add-service-button"
				>
					{t("organization.data.add_service")}
				</Button>
			</Can>
			{addServiceModal.isOpen && (
				<AddServiceModal
					isOpen={addServiceModal.isOpen}
					onClose={addServiceModal.onClose}
					onComplete={handleOnComplete}
				/>
			)}
		</React.Fragment>
	);
}
